import { Button, Icon, Tooltip } from '@nimbus-ds/components';
import { useResponsive } from 'commons/components';
import { trackingSavedSearchConfigOpen } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ReactComponent as QuickfilterIconHigh } from './images/QuickfilterIconHigh.svg';
import { ReactComponent as QuickfilterIconLow } from './images/QuickfilterIconLow.svg';
import { useSavedSearches } from './useSavedSearches';

interface SavedSearchesConfigButtonProps {
  onClick: () => void;
}

export function SavedSearchesConfigButton({
  onClick,
}: Readonly<SavedSearchesConfigButtonProps>) {
  const { isApiSavedSearchesEnabled } = useSavedSearches();
  const { isMobile } = useResponsive();
  const t = useTranslationOrders();

  const handleClick = () => {
    trackingSavedSearchConfigOpen();
    onClick();
  };

  if (!isApiSavedSearchesEnabled) {
    return null;
  }

  return (
    <Tooltip
      content={t('savedSearches.configModal.title')}
      position="bottom"
      arrow
    >
      <Button
        appearance={isMobile ? 'neutral' : 'transparent'}
        onClick={handleClick}
      >
        <Icon
          source={
            isMobile ? (
              <QuickfilterIconLow
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                fill="currentColor"
              />
            ) : (
              <QuickfilterIconHigh
                width="16px"
                height="16px"
                viewBox="0 0 16 16"
                fill="currentColor"
              />
            )
          }
        />
      </Button>
    </Tooltip>
  );
}
